/* eslint-disable react/no-children-prop */
/* eslint-disable @typescript-eslint/no-var-requires */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react'
import Fields from './field'
import {
  FormControl,
  FormLabel,
  FormHelperText,
  FormErrorMessage,
  InputGroup,
  InputRightElement,
  InputLeftElement
} from '@chakra-ui/react'
import InputMask from 'react-input-mask'
import { Controller, UseFormSetValue } from 'react-hook-form'

interface Props {
  label?: string
  isError?: string
  isRequired?: boolean
  props?: HTMLInputElement
  id?: string
  isHidden?: boolean
  isHelper?: string
  select?: string
  value?: any
  onChange?: (param: any) => void
  options: any[]
  isDisabled?: boolean
  placeholder?: string
  mt?: string
  mb?: string
  startDate: Date
  register?: any
  children?: React.ReactNode
  IconLeft?: any
  IconRight?: any
  setValue?: UseFormSetValue<any> | undefined
  control?: any
}

function FormItem({
  label,
  isRequired,
  isError,
  id,
  isHidden,
  isHelper,
  select,
  options,
  value,
  onChange,
  isDisabled,
  placeholder,
  mt,
  mb,
  startDate,
  register,
  children,
  IconRight,
  IconLeft,
  setValue,
  control
}: Props): JSX.Element {
  return (
    <FormControl
      id={id}
      isRequired={isRequired ?? false}
      hidden={isHidden}
      w="100%"
      mt={mt}
      mb={mb}
      isInvalid={isError !== ''}
    >
      {label !== null ? (
        <FormLabel fontSize="20px" fontWeight="bold" color="#616161">
          {label}
        </FormLabel>
      ) : null}
      <FormHelperText fontSize="14px" color="#b6b6b6" mb="7px">
        {isHelper}
      </FormHelperText>
      {select === 'radio' ? <Fields.radio value={value} onChange={onChange} options={options} /> : null}
      {select === 'input' ? (
        <Fields.input
          height="40px"
          fontSize="18px"
          fontWeight="400"
          placeholder={placeholder}
          borderRadius="8px"
          border="1px solid #E5E5E5"
          isDisabled={isDisabled}
          _disabled={{
            background: '#F5F5F5'
          }}
          {...register(id)}
        />
      ) : null}
      {select === 'inputGroup' ? (
        <InputGroup>
          {IconLeft !== null ? <InputLeftElement children={IconLeft} /> : null}
          <Fields.input
            height="40px"
            fontSize="18px"
            fontWeight="400"
            placeholder={placeholder}
            borderRadius="8px"
            border="1px solid #E5E5E5"
            isDisabled={isDisabled}
            _disabled={{
              background: '#F5F5F5'
            }}
            {...register(id)}
          />
          {IconRight !== null ? <InputRightElement children={IconRight} /> : null}
        </InputGroup>
      ) : null}
      {select === 'phone' ? (
        <InputMask mask="9999999999" name="mobileNumber" {...register(id)}>
          {(inputProps: any) => (
            <Fields.input
              {...inputProps}
              id="mobileNumber"
              type="tel"
              pattern="\d*"
              height="40px"
              fontSize="18px"
              fontWeight="400"
              placeholder={placeholder}
              borderRadius="8px"
              border="1px solid #E5E5E5"
              isDisabled={isDisabled}
              _disabled={{
                background: '#F5F5F5'
              }}
            />
          )}
        </InputMask>
      ) : null}
      {select === 'dateTime' ? (
        <Controller
          control={control}
          name={id ?? ''}
          render={function ({ field }): JSX.Element {
            return (
              <Fields.dateTime
                id={id}
                width="100%"
                value={field.value ?? null}
                onChange={(date: Date) => field.onChange(date)}
                placeholder={placeholder}
              />
            )
          }}
        />
      ) : null}
      {select === 'googleMap' ? (
        <InputGroup onClick={onChange}>
          {IconLeft !== null ? <InputLeftElement children={IconLeft} /> : null}
          <Fields.input
            height="40px"
            fontSize="18px"
            fontWeight="400"
            placeholder={placeholder}
            borderRadius="8px"
            border="1px solid #E5E5E5"
            isDisabled={isDisabled}
            _disabled={{
              background: '#F5F5F5'
            }}
            isReadOnly
            {...register(id)}
          />
          {IconRight !== null ? <InputRightElement children={IconRight} /> : null}
        </InputGroup>
      ) : null}
      {children}
      <FormErrorMessage fontSize="14px">{isError}</FormErrorMessage>
    </FormControl>
  )
}

FormItem.defaultProps = {
  id: '',
  isHidden: false,
  isDisabled: false,
  placeholder: '',
  options: [],
  mt: '0px',
  mb: '0px',
  startDate: new Date(),
  value: '',
  isError: ''
}

export default FormItem
